/**
 * Polyfill Symbol.metadata
 * @see https://github.com/microsoft/TypeScript/issues/53461
 */
Symbol.metadata ??= Symbol.for('Symbol.metadata');
/**
 * Initializes the struct metadata for a class
 * This also handles copying metadata from parent classes
 */
export function initMetadata(context) {
    context.metadata ??= {};
    const existing = context.metadata.structInit ?? {};
    context.metadata.structInit = {
        fields: [...(existing.fields ?? [])],
    };
    return context.metadata.structInit;
}
export function isValidMetadata(arg) {
    return arg != null && typeof arg == 'object' && 'struct' in arg;
}
export function isStatic(arg) {
    return typeof arg == 'function' && Symbol.metadata in arg && isValidMetadata(arg[Symbol.metadata]);
}
export function isInstance(arg) {
    return arg != null && typeof arg == 'object' && isStatic(arg.constructor);
}
export function checkInstance(arg) {
    if (isInstance(arg))
        return;
    throw new TypeError((typeof arg == 'function' ? arg.name : typeof arg == 'object' && arg ? arg.constructor.name : arg)
        + ' is not a struct instance');
}
export function isStruct(arg) {
    return isInstance(arg) || isStatic(arg);
}
export function checkStruct(arg) {
    if (isStruct(arg))
        return;
    throw new TypeError((typeof arg == 'function' ? arg.name : typeof arg == 'object' && arg ? arg.constructor.name : arg)
        + ' is not a struct');
}
